// extracted by mini-css-extract-plugin
export default {"wrapper":"DrawerSlot_wrapper__uC5zD","drawerWrapper":"DrawerSlot_drawerWrapper__tewWi","content":"DrawerSlot_content__5hNMr"};